import moment from 'moment';

import { formatISOToDate } from '@utils/dateUtil';

export const formatValidTourDate = (date?: string): string => {
  if (!date || !moment.utc(date, moment.ISO_8601, true).isValid()) return '';

  return formatISOToDate(date);
};

export const formatValidDepartureTime = (dateTime?: string): string => {
  if (!dateTime) return '';

  const parsedDate = moment(
    dateTime,
    ['DD/MM/YYYY HH:mm:ss', 'HH:mm:ss', 'HH:mm'],
    true
  );
  return parsedDate.isValid() ? parsedDate.format('HH:mm') : '';
};
